export default __webpack_public_path__ + "static/media/dashboard-icon-active (1).775c38d4.svg";